// extracted by mini-css-extract-plugin
export default {"container":"Slider_container__2d9I9","label":"Slider_label__KU-u0"};